export function printObj(obj){
	for(var prop in obj){
		try {
			console.log("prop : " + prop + " value : " + obj[prop])
		}catch (e) {
			
		}
	}
}